class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce(event => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;

    const resetIsHidden = this.resetButton.classList.contains('hidden');

    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  filterSearchTerm(term) {
    // Only allow letters, numbers, spaces, hyphens, and ampersands
    // Convert to lowercase to make it case-insensitive
    return term.toLowerCase().replace(/[^a-z0-9\s\-&]/g, '').trim();
  }

  onFormSubmit(event) {
    const rawTerm = this.input.value.trim();
    const filteredTerm = this.filterSearchTerm(rawTerm);
    const hasValidChar = /[a-zA-Z0-9]/.test(rawTerm);

    // If only special chars, prevent submit
    if (
      !hasValidChar ||
      !filteredTerm.length ||
      filteredTerm.length < 2 ||
      this.querySelector('[aria-selected="true"] a')
    ) {
      event.preventDefault();
      return;
    }

    // Pass the filtered term to the actual search submission
    this.input.value = filteredTerm;
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
